/**
 * Utilidades de búsqueda de texto para filtrado client-side.
 *
 * Los listados de Usuarios y Clientes se cargan completos desde Firestore,
 * así que el filtrado se hace en memoria: en vivo (cada tecla), insensible
 * a mayúsculas y tildes, y por múltiples palabras (todas deben aparecer,
 * en cualquier orden y en cualquier parte del texto).
 */

const DIACRITICS = /[̀-ͯ]/g;

/** minúsculas + sin tildes/diacríticos: "Pérez" → "perez" */
export const normalizeText = (value) =>
  String(value ?? '')
    .toLowerCase()
    .normalize('NFD')
    .replace(DIACRITICS, '');

/**
 * ¿El texto (haystack) contiene TODAS las palabras de la consulta?
 * @param {string} haystack texto donde buscar (se normaliza aquí)
 * @param {string} query    lo que escribió el usuario
 */
export const matchesSearch = (haystack, query) => {
  const q = normalizeText(query).trim();
  if (!q) return true;
  const hay = normalizeText(haystack);
  return q.split(/\s+/).every(term => hay.includes(term));
};
